import React, { useId, useState } from "react";
import './UploadButton.css';

function UploadButton({
    uploadMethod,
    buttonName = "Upload",
    disabled = false,
    accept,
    title,
    style
}) {
    const [fileName, setFileName] = useState("");
    const inputId = useId();

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        // Limpa o input para permitir selecionar o mesmo arquivo novamente
        event.target.value = '';
        if (file) {
            setFileName(file.name);
            uploadMethod(file);
        }
    };

    const buttonStyle = {
        minWidth: '80px',
        float: 'right',
        color: disabled ? 'rgba(32, 27, 35, 0.53)' : 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        alignContent: 'center',
        ...style
    };

    return (
        <div className="upload-button-wrapper" style={buttonStyle}>
            <input
                type="file"
                id={inputId}
                accept={accept}
                disabled={disabled}
                onChange={handleFileChange}
                style={{ display: "none" }}
            />
            <label
                htmlFor={disabled ? undefined : inputId}
                style={{ padding: '5px', cursor: disabled ? 'not-allowed' : 'pointer' }}
                className={`button-field`}
                title={title}
            >
                {buttonName}
            </label>
            {fileName && <span className="file-name">{fileName}</span>}
        </div>
    );
}

export default UploadButton;
